import React, { useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { LoadingButton } from '@mui/lab';
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { TextField, IconButton, InputAdornment } from '@mui/material';
import useAuth from 'app/hooks/useAuth';
import { useScript } from 'app/hooks/useScript';
import jwt_decode from 'jwt-decode';
import { Formik } from 'formik';
import * as Yup from 'yup';
import 'app/asset/css/bootstrap.css'
import 'app/asset/css/bootstrap.min.css'
import 'app/asset/libs/fontawesome-free/css/all.min.css'
import "./login.css"
import * as DOMPurify from 'dompurify';

const initialValues = {
  email: '',
  password: '',
  remember: true,
};

const validationSchema = Yup.object().shape({
  password: Yup.string()
    .min(6, 'Password must be 6 character length')
    .required('Password is required!'),
  email: Yup.string().email('Invalid Email address').required('Email is required!'),
});

const JwtLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const googlebuttonref = useRef();
  const { glogin, login } = useAuth();
  const [showPassword, setShowPassword] = useState(false);

  const onGoogleSignIn = async(user) => {
    let userCred = user.credential;
    let payload = jwt_decode(userCred);
    await glogin(payload.email, payload.name, payload.picture);
    navigate('/');
  };
  useScript("https://accounts.google.com/gsi/client", () => {
    window.google.accounts.id.initialize({
      client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
      callback: onGoogleSignIn,
      auto_select: false,
      useOneTap : false
    });

    window.google.accounts.id.renderButton(googlebuttonref.current, {
      theme: "filled_black",
      logo_alignment : "left",
      size: "large",
      shape: "rectangular",
      width: '260px'
    });    
  });

  const handleFormSubmit = async (values) => {
    setLoading(true);
    try {
      await login(DOMPurify.sanitize(values.email), DOMPurify.sanitize(values.password));
      navigate('/');
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container">
      <div className="floating-squares">
        <span></span>
        <span></span>
        <span></span>
      </div>
        <div className="card card-login">
          <div className="card-body">
            <div className="form-group row">
              <div className="text-center">
                <img src="/assets/images/logo-dashboard.png" className="imgLogo" alt="PT. Pyridham Farma, Tbk" />
              </div>
            </div>
            <div className="form-group row mt-3 mb-1">
              <Formik
                onSubmit={handleFormSubmit}
                initialValues={initialValues}
                validationSchema={validationSchema}
              >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                  <form onSubmit={handleSubmit}>
                    <TextField
                      fullWidth
                      size="small"
                      type="email"
                      name="email"
                      label="Email"
                      variant="outlined"
                      onBlur={handleBlur}
                      value={values.email}
                      onChange={handleChange}
                      helperText={touched.email && errors.email}
                      error={Boolean(errors.email && touched.email)}
                      autoComplete='off'
                      sx={{ mb: 3 }}
                    />

                    <TextField
                      fullWidth
                      size="small"
                      name="password"
                      label="Password"
                      variant="outlined"
                      type={showPassword ? "text" : "password"}
                      onBlur={handleBlur}
                      value={values.password}
                      onChange={handleChange}
                      helperText={touched.password && errors.password}
                      error={Boolean(errors.password && touched.password)}
                      autoComplete="off"
                      sx={{ mb: 1 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword((prev) => !prev)}
                              edge="end"
                            >
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                    <LoadingButton
                      type="submit"
                      color="error"
                      loading={loading}
                      variant="contained"
                      fullWidth
                    >
                      Sign in
                    </LoadingButton>
                    <div className="appInit">
                      <div style={{paddingTop: '5px'}} ref={googlebuttonref}></div>
                    </div>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </div>
        <div className="footer">
          <div className="text-center text-white small">
            © {new Date().getFullYear()} | All Rights Reserved | Built by <strong>IT Division</strong>
          </div>
        </div>
      </div>
    </>
  );
};

export default JwtLogin;
